<!--:tree-props="{children: 'children', hasChildren: 'hasChildren'}"-->
<template>
    <div class="app-container">
        <div class="filter-container">
            <el-input v-model="listQuery.username" placeholder="用户名" style="width: 200px;"
                      class="filter-item" @keyup.enter.native="handleFilter"/>

            <el-input v-model="listQuery.real_name" placeholder="真实姓名" style="width: 200px;"
                      class="filter-item" @keyup.enter.native="handleFilter"/>
            <el-input v-model="listQuery.telephone" placeholder="手机号" style="width: 200px;"
                      class="filter-item" @keyup.enter.native="handleFilter"/>

            <el-select filterable v-model="listQuery.is_admin" clearable style="width: 140px" class="filter-item"
                       placeholder="账号权限" @change="handleFilter">
                <el-option
                        v-for="item in tags"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>

            <el-select v-model="listQuery.sort" style="width: 140px" class="filter-item" @change="handleFilter">
                <el-option v-for="item in sortOptions" :key="item.key" :label="item.label" :value="item.key"/>
            </el-select>
            <!--<el-select v-model="listQuery.tag" style="width: 140px" class="filter-item" clearable @change="handleFilter">-->
            <!--<el-option v-for="item in tags" :key="item.id" :label="item.name" :value="item.key"/>-->
            <!--</el-select>-->
            <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
                {{ $t('table.search') }}
            </el-button>
            <el-button class="filter-item" style="margin-left: 10px;" type="primary" icon="el-icon-edit"
                       @click="handleCreate">
                {{ $t('table.add') }}
            </el-button>
            <!--<el-button v-waves :loading="downloadLoading" class="filter-item" type="primary" icon="el-icon-download"-->
            <!--@click="handleDownload">-->
            <!--{{ $t('table.export') }}-->
            <!--</el-button>-->
        </div>

        <el-table
                :key="tableKey"
                v-loading="listLoading"
                :data="list"
                border
                fit
                lazy

                highlight-current-row
                style="width: 100%;"
                @sort-change="sortChange"
                row-key="id"
                :load="load"
                :tree-props="{children: 'children', hasChildren: 'hasChildren'}"

        >
            <!--<el-table-column label="序号" prop="id" sortable="custom" align="center" width="80"-->
            <!--:class-name="getSortClass('id')">-->
            <!--<template slot-scope="{row}">-->
            <!--<span>{{ row.id }}</span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <el-table-column label="用户名" width="150px" align="center">
                <template slot-scope="{row}">
                    <span>{{ row.username }}</span>
                </template>
            </el-table-column>
            <el-table-column label="手机号" min-width="150px">
                <template slot-scope="{row}">
                    <span class="link-type">{{ row.telephone }}</span>
                </template>
            </el-table-column>
            <el-table-column label="真实姓名" min-width="150px">
                <template slot-scope="{row}">
                    <span class="link-type">{{ row.real_name }}</span>
                </template>
            </el-table-column>
            <el-table-column label="账号权限" min-width="150px">
                <template slot-scope="{row}">
                    <span class="link-type">{{ row.is_admin == '1' ? '管理员' : '子账号' }}</span>
                </template>
            </el-table-column>

            <!--<el-table-column label="标签" width="80px">-->
            <!--<template slot-scope="{row}">-->
            <!--<span class="link-type" v-for="(item,i) in row.tags">{{ item.name }} {{ item.telphone }}  {{ item.email }}<br/></span>-->
            <!--</template>-->
            <!--</el-table-column>-->
            <el-table-column label="备注" width="80px">
                <template slot-scope="{row}">
                    <span>{{ row.remarks }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('table.actions')" align="center" width="230"
                             class-name="small-padding fixed-width">
                <template slot-scope="{row,$index}">
                    <el-button type="primary" size="mini" @click="handleUpdate(row)">
                        {{ $t('table.edit') }}
                    </el-button>
                    <el-button size="mini" type="danger"
                               @click="handleDelete(row.id,$index)">
                        删除
                    </el-button>
                    <!--<el-button v-if="row.prohibit ==1" size="mini" type="info"-->
                    <!--@click="handleDelete(row.id,$index)">-->
                    <!--启用-->
                    <!--</el-button>-->
                </template>
            </el-table-column>
        </el-table>

        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
                    @pagination="getList"/>

        <el-dialog v-dialogDrag :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible">
            <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="90px"
                     style="width: 400px; margin-left:50px;">
                <input type="hidden" v-model="temp.id">
                <el-form-item label="用户名" prop="username">
                    <el-input v-model="temp.username"></el-input>
                </el-form-item>


                <!--<el-form-item label="真实姓名" prop="real_name">-->
                   <!-- <el-input v-model="temp.real_name"/>-->
               <!-- </el-form-item>-->
                <el-form-item label="真实姓名" prop="real_name">
                 <el-autocomplete
                                    popper-class="my-autocomplete"
                                    v-model="temp.real_name"
                                    :fetch-suggestions="querySearch"
                                    placeholder="请输入姓名"
                                    @select="(item) => {handleSelect(item,index)}">
                                <i
                                        class="el-icon-edit el-input__icon"
                                        slot="suffix"
                                        @click="handleIconClick">
                                </i>
                                <template slot-scope="{ item }">
                                    <div class="name">{{ item.value }}</div>
                                    <span class="addr">{{ item.address }}</span>
                                </template>
                            </el-autocomplete>
                </el-form-item>
                             <el-form-item label="手机号" prop="telephone">
                    <el-input v-model="temp.telephone"/>
                </el-form-item>

                <el-form-item label="密码" prop="password">
                    <el-input v-model="temp.password" show-password/>
                </el-form-item>


                <el-form-item label="账号权限" prop="is_admin">
                    <el-select v-show="dialogStatus==='create'"
                               v-model="temp.is_admin"
                               allow-create
                               default-first-option
                               placeholder="请选择标签">
                        <el-option
                                v-for="item in tags"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>

                    <el-input v-show="dialogStatus==='update'" v-model="temp.is_admin ==1 ? '管理员' :'子账号'"
                              disabled="true"/>
                </el-form-item>
                <el-form-item label="备注" prop="remarks">
                    <el-input v-model="temp.remarks"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">
                    {{ $t('table.cancel') }}
                </el-button>
                <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">
                    {{ $t('table.confirm') }}
                </el-button>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="dialogPvVisible" title="Reading statistics">
            <el-table :data="pvData" border fit highlight-current-row style="width: 100%">
                <el-table-column prop="key" label="Channel"/>
                <el-table-column prop="pv" label="Pv"/>
            </el-table>
            <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveSync">{{ $t('table.confirm') }}</el-button>
      </span>
        </el-dialog>
    </div>
</template>

<script>
  import { fetchList, delUser, createUser, updateUser, delManger, getAllTags, getChildrens , getAllInfo } from '@/api/user'
  import waves from '@/directive/waves' // waves directive
  import { parseTime } from '@/utils'
  import Pagination from '@/components/Pagination' // secondary package based on el-pagination

  const calendarTypeOptions = [
    { key: 'CN', display_name: 'China' },
    { key: 'US', display_name: 'USA' },
    { key: 'JP', display_name: 'Japan' },
    { key: 'EU', display_name: 'Eurozone' }
  ]

  // arr to obj, such as { CN : "China", US : "USA" }
  const calendarTypeKeyValue = calendarTypeOptions.reduce((acc, cur) => {
    acc[cur.key] = cur.display_name
    return acc
  }, {})

  export default {
    name: 'ComplexTable',
    components: { Pagination },
    directives: { waves },
    filters: {
      statusFilter(status) {
        const statusMap = {
          published: 'success',
          draft: 'info',
          deleted: 'danger'
        }
        return statusMap[status]
      },
      typeFilter(type) {
        return calendarTypeKeyValue[type]
      }
    },
    data() {
      return {
        restaurants: [], // 全局搜索手机号姓名  存储
        tags: [{ 'id': '1', 'name': '管理员' }, { 'id': '0', 'name': '子账号' }],
        tableKey: 0,
        list: null,
        total: 0,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 20,
          telephone: '',
          real_name: undefined,
          is_admin: undefined,
          sort: '-id',
          tag: ''
        },
        importanceOptions: [1, 2, 3],
        calendarTypeOptions,
        sortOptions: [{ label: 'ID 正序', key: '+id' }, { label: 'ID 倒序', key: '-id' }],
        statusOptions: ['published', 'draft', 'deleted'],

        temp: {
          id: undefined,
          com_name: '',
          manager: [],
          address: '',
          url: '',
          remarks: '',
          tags: []
        },
        dialogFormVisible: false,
        dialogStatus: '',
        textMap: {
          update: '编辑',
          create: '新增'
        },
        dialogPvVisible: false,
        pvData: [],
        rules: {
          username: [{ required: true, message: '用户名必须填写', trigger: 'change' }],
          telephone: [{ required: true, message: '手机号必须填写', trigger: 'change' }],
          real_name: [{ required: true, message: '真实姓名必须填写', trigger: 'change' }],
          password: [{ required: true, message: '密码必须填写', trigger: 'change' }],
          is_admin: [{ required: true, message: '账号权限必须填写', trigger: 'change' }]
        },
        downloadLoading: false
      }
    },
    created() {
      this.loadAll()
      this.getList()
      this.getAllTags()

    },
    methods: {
      querySearch(queryString, cb) {
        var restaurants = this.restaurants
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants
        // 调用 callback 返回建议列表的数据
        cb(results)
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
        }
      },
      loadAll() {
        getAllInfo().then(response => {
          console.log(response.data)
          this.restaurants =  response.data
        })
      },
      handleSelect(item,index) {
        // alert(item['address'])
        this.temp.telephone = item['address']
      },
      handleIconClick(ev) {
        console.log(ev)
      },



      load(tree, treeNode, resolve) {
        getChildrens(tree.id).then(response => {
          resolve(response.data)
        })
      },
      getAllTags() {
        getAllTags().then(response => {
          this.tags = response.data
        })
      },
      removeManager(listID, index) {
        if (this.dialogStatus == 'update') {
          for (var i = 0; i < this.list.length; i++) {
            if (this.list[i].id == listID) {
              if (this.list[i].manager[index].id != 0) {
                delManger(this.list[i].manager[index].id).then(response => {
                  this.$message({
                    message: '操作成功',
                    type: 'success'
                  })
                })
              }
              this.list[i].manager.splice(index, 1)
              return false
            }
          }
        } else {
          this.temp.manager.splice(index, 1)
        }

      },
      addManager(customer_id) {
        if (this.dialogStatus == 'update') {
          for (var i = 0; i < this.list.length; i++) {
            if (customer_id == this.list[i].id) {
              this.list[i].manager.push({
                'id': 0
              })
              // extend(this.list[i].manager,{});
              return false
            }
          }
        } else {
          this.temp.manager.push({
            'id': 0
          })
        }

      },
      getList() {
        this.listLoading = true
        fetchList(this.listQuery).then(response => {
          console.log(response.data.items)
          this.list = response.data.items
          this.total = response.data.total

          // Just to simulate the time of the request
          setTimeout(() => {
            this.listLoading = false
          }, 1.5 * 1000)
        })
      },
      handleFilter() {
        this.listQuery.page = 1
        this.getList()
      },
      handleModifyStatus(row, status) {
        this.$message({
          message: '操作成功',
          type: 'success'
        })
        row.status = status
      },
      sortChange(data) {
        const { prop, order } = data
        if (prop === 'id') {
          this.sortByID(order)
        }
      },
      sortByID(order) {
        if (order === 'ascending') {
          this.listQuery.sort = '+id'
        } else {
          this.listQuery.sort = '-id'
        }
        this.handleFilter()
      },
      resetTemp() {
        this.temp = {
          id: undefined,
          com_name: '',
          manager: [{
            'id': 0
          }],
          address: '',
          url: '',
          remarks: '',
          tags: []
        }
      },
      handleCreate() {
        this.resetTemp()
        this.dialogStatus = 'create'
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      createData() {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.temp.id = parseInt(Math.random() * 100) + 1024 // mock a id
            createUser(this.temp).then(() => {
              this.list.unshift(this.temp)
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '创建成功',
                type: 'success',
                duration: 2000
              })
              this.getList()
              this.getAllTags()
            })
          }
        })

      },
      handleUpdate(row) {
        this.temp = Object.assign({}, row) // copy obj
        this.temp.timestamp = new Date(this.temp.timestamp)
        if (row.tags) {
          this.temp.tags = []
          for (var i = 0; i < row.tags.length; i++) {
            this.temp.tags.push(row.tags[i].tag)
          }
        }

        this.dialogStatus = 'update'
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      updateData() {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            const tempData = Object.assign({}, this.temp)
            updateUser(tempData).then(() => {
              const index = this.list.findIndex(v => v.id === this.temp.id)
              this.list.splice(index, 1, this.temp)
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '更新成功',
                type: 'success',
                duration: 2000
              })
              this.getList()
              this.getAllTags()
            })
          }
        })

      },
      handleDelete(customer_id, index) {
        this.$confirm('删除账号，同时删除账号录入的信息?', '提醒', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            delUser(customer_id).then(() => {
              this.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success',
                duration: 2000
              })
              // this.list.splice(index, 1)
              this.getList()
            })
          })

      },
      handleDownload() {
        this.downloadLoading = true

        import('@/vendor/Export2Excel').then(excel => {
          const tHeader = ['公司名称', '公司地址', '备注', '负责人信息']
          const filterVal = ['com_name', 'address', 'remarks', 'customer']
          const data = this.formatJson(filterVal)
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: 'table-list'
          })
          this.downloadLoading = false
        })
      },
      formatJson(filterVal) {
        return this.list.map(v => filterVal.map(j => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        }))
      },
      getSortClass: function(key) {
        const sort = this.listQuery.sort
        return sort === `+${key}` ? 'ascending' : 'descending'
      }
    }
  }
</script>
